import axios from '@/utilities/axios-global'

export function POST_DOCUPLOADALERT(context, payload) {
  return new Promise((resolve, reject) => {
    if (payload.documents.length) {
      axios.post(context.rootState.user.baseApiUrl + '/emailalerts/docuploadalert', payload).then(response => {
        resolve(response)
      }, error => {
        console.log(error)
        reject(error)
      })
    }
    resolve()
  })
}

export default {
  POST_DOCUPLOADALERT
}
